import { useState } from "react";
import { createContext } from "react";

export const ProfileDataContext = createContext({
    profile: {},
    setProfile: () => { },
})


export const ProfileDataContextProvider = ({ children }) => {
    const [ profile, setProfile ] = useState();
    
    return <ProfileDataContext.Provider value={{profile, setProfile}}>{children}</ProfileDataContext.Provider>
}